import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { SEO } from '../utils/seo';
export function CommentAdhererPage() {
  const conditions = ["Être un établissement d'hébergement touristique classé ;", 'Exercer son activité dans le ressort territorial de la région Souss Massa ;', 'Adhérer sans réserve aux présents statuts, et au règlement intérieur ;', "Produire tous les documents nécessaires justifiant l'existence légale de l'établissement conformément aux lois et aux règlements en vigueur ;", "S'acquitter, dans les délais prescrits, de la cotisation annuelle ;", "Présenter une délégation de pouvoir délivrée par le représentant légal de l'établissement d'hébergement touristique au profit du gestionnaire exploitant ou directeur en exercice, conformément au règlement intérieur."];
  return <div className="min-h-screen bg-white" data-id="element-248">
      <SEO title="Comment Adhérer" description="Adhérez à l'ARIH Agadir Souss Massa - Conditions d'adhésion, barème des cotisations annuelles pour les établissements hôteliers de la région" keywords="adhésion ARIH, cotisation hôtel Agadir, membre ARIH, rejoindre association hôtelière" data-id="element-249" />
      <Navbar data-id="element-250" />

      {/* Hero */}
      <section className="bg-arih-blue py-24 md:py-32" data-id="element-251">
        <div className="container mx-auto px-4 md:px-8 text-center" data-id="element-252">
          <h1 className="text-[42px] md:text-[56px] font-semibold text-white leading-tight mb-6" data-id="element-253">
            Comment Adhérer à l'ARIH Agadir Souss Massa
          </h1>
          <p className="text-[20px] text-white/90 leading-[32px] max-w-2xl mx-auto" data-id="element-254">
            Développer l'industrie hôtelière et le tourisme dans la région de
            Agadir Souss Massa
          </p>
        </div>
      </section>

      {/* Conditions */}
      <section className="bg-white py-20 px-4 md:px-8" data-id="element-255">
        <div className="container mx-auto max-w-4xl" data-id="element-256">
          <h2 className="text-[36px] md:text-[40px] font-bold text-arih-dark mb-12" data-id="element-257">
            Conditions d'adhésion
          </h2>

          <div className="space-y-0" data-id="element-258">
            {conditions.map((condition, index) => <div key={index} className="flex gap-6 py-5 border-b border-gray-200" data-id="element-259">
                <span className="text-[24px] font-bold text-arih-blue min-w-[48px]" data-id="element-260">
                  {String(index + 1).padStart(2, '0')}.
                </span>
                <p className="text-[18px] text-arih-dark leading-[28px] pt-1" data-id="element-261">
                  {condition}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Cotisations Table */}
      <section className="bg-arih-light-bg py-20 px-4 md:px-8" data-id="element-262">
        <div className="container mx-auto max-w-5xl" data-id="element-263">
          <h2 className="text-[36px] md:text-[40px] font-bold text-arih-dark mb-12" data-id="element-264">
            Barème des cotisations annuelles
          </h2>

          <div className="overflow-x-auto rounded-xl shadow-sm" data-id="element-265">
            <table className="w-full bg-white" data-id="element-266">
              <thead data-id="element-267">
                <tr className="bg-arih-blue text-white" data-id="element-268">
                  <th className="px-6 py-4 text-left text-[14px] font-semibold uppercase" data-id="element-269">
                    CATÉGORIE HÔTEL
                  </th>
                  <th className="px-6 py-4 text-left text-[14px] font-semibold uppercase" data-id="element-270">
                    FIXE
                  </th>
                  <th className="px-6 py-4 text-left text-[14px] font-semibold uppercase" data-id="element-271">
                    0 À 100 CHB.
                  </th>
                  <th className="px-6 py-4 text-left text-[14px] font-semibold uppercase" data-id="element-272">
                    101 À 200 CHB.
                  </th>
                  <th className="px-6 py-4 text-left text-[14px] font-semibold uppercase" data-id="element-273">
                    201 À 300 CHB.
                  </th>
                  <th className="px-6 py-4 text-left text-[14px] font-semibold uppercase" data-id="element-274">
                    301 ET PLUS
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-275">
                <tr className="border-b border-gray-200" data-id="element-276">
                  <td className="px-6 py-4 text-[16px] text-arih-dark font-medium" data-id="element-277">
                    Luxe
                  </td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-278">
                    10 000
                  </td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-279">
                    8 000
                  </td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-280">
                    12 000
                  </td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-281">
                    20 000
                  </td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-282">
                    24 000
                  </td>
                </tr>
                <tr className="bg-arih-light-bg border-b border-gray-200" data-id="element-283">
                  <td className="px-6 py-4 text-[16px] text-arih-dark font-medium" data-id="element-284">
                    5 étoiles
                  </td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-285">
                    8 000
                  </td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-286">
                    6 000
                  </td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-287">
                    10 000
                  </td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-288">
                    14 000
                  </td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-289">
                    18 000
                  </td>
                </tr>
                <tr className="border-b border-gray-200" data-id="element-290">
                  <td className="px-6 py-4 text-[16px] text-arih-dark font-medium" data-id="element-291">
                    4 étoiles
                  </td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-292">
                    6 000
                  </td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-293">
                    6 000
                  </td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-294">
                    8 000
                  </td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-295">
                    12 000
                  </td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-296">
                    16 000
                  </td>
                </tr>
                <tr className="bg-arih-light-bg border-b border-gray-200" data-id="element-297">
                  <td className="px-6 py-4 text-[16px] text-arih-dark font-medium" data-id="element-298">
                    3 étoiles
                  </td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-299">
                    4 000
                  </td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-300">
                    4 000
                  </td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-301">
                    6 000
                  </td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-302">
                    10 000
                  </td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-303">
                    14 000
                  </td>
                </tr>
                <tr className="border-b border-gray-200" data-id="element-304">
                  <td className="px-6 py-4 text-[16px] text-arih-dark font-medium" data-id="element-305">
                    2 étoiles
                  </td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-306">
                    2 500
                  </td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-307">
                    2 000
                  </td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-308">—</td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-309">—</td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-310">—</td>
                </tr>
                <tr className="bg-arih-light-bg" data-id="element-311">
                  <td className="px-6 py-4 text-[16px] text-arih-dark font-medium" data-id="element-312">
                    1 étoile
                  </td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-313">—</td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-314">
                    1 000
                  </td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-315">—</td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-316">—</td>
                  <td className="px-6 py-4 text-[16px] text-arih-dark" data-id="element-317">—</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p className="text-[18px] text-arih-gray italic mt-8 leading-[32px]" data-id="element-318">
            Il faut opérer comme suit : Additionner le montant fixe propre à
            votre catégorie au montant correspondant à la tranche de chambres où
            se situe votre établissement.
          </p>
        </div>
      </section>

      <Footer data-id="element-319" />
    </div>;
}